import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const BuildingIcon: FC<SVGProps<SVGSVGElement>> = props => {
	return (
		<SvgIcon width={26} height={24} viewBox='0 0 26 24' {...props}>
			<g fill='none' fillRule='evenodd' transform='translate(1 2)'>
				<polygon fill='currentColor' points='4.999 9 2.999 9 2.999 11 4.999 11' />
				<polygon fill='currentColor' points='4.999 13 2.999 13 2.999 15 4.999 15' />
				<polygon stroke='currentColor' strokeLinejoin='round' strokeWidth='2' points='8 6 0 6 0 19 8 19' />
				<polygon fill='currentColor' points='12.999 3 10.999 3 10.999 5 12.999 5' />
				<polygon fill='currentColor' points='16.999 3 14.999 3 14.999 5 16.999 5' />
				<polygon fill='currentColor' points='12.999 7 10.999 7 10.999 9 12.999 9' />
				<polygon fill='currentColor' points='16.999 7 14.999 7 14.999 9 16.999 9' />
				<polygon fill='currentColor' points='20.999 3 18.999 3 18.999 5 20.999 5' />
				<polygon fill='currentColor' points='20.999 7 18.999 7 18.999 9 20.999 9' />
				<path stroke='currentColor' strokeLinejoin='round' strokeWidth='2' d='M24,-1 L24,19 L8,19 L8,-1 L24,-1 Z' />
				<path
					stroke='currentColor'
					strokeWidth='2'
					d='M17,14 C17.2761424,14 17.5261424,14.1119288 17.7071068,14.2928932 C17.8880712,14.4738576 18,14.7238576 18,15 L18,19 L14,19 L14,15 C14,14.7238576 14.1119288,14.4738576 14.2928932,14.2928932 C14.4738576,14.1119288 14.7238576,14 15,14 Z'
				/>
				<polygon fill='currentColor' points='2.999 20 11.739 20 11.739 18.703 3.043 18.703' />
			</g>
		</SvgIcon>
	);
};
